module.exports = __webpack_public_path__ + "img/nextw.0159aaf1.png";